// extracted by mini-css-extract-plugin
module.exports = {"mapWrapper":"OpenLayersMap_mapWrapper__jJTzs","debugOverlay":"OpenLayersMap_debugOverlay__3imQf"};